import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'supply_chain_tier'

export const dataPointDefinition = {
  retracedId: 'supply_chain_tier',
  name: 'Supply Chain Tier',
  meta: {},
  fieldTypeId: 'MULTI_SELECT',
  type: 'TRANSACTIONAL',
  options: [
    {
      key: 'TIER_0',
      text: 'Tier 0',
    },
    {
      key: 'TIER_1',
      text: 'Tier 1',
    },
    {
      key: 'TIER_2',
      text: 'Tier 2',
    },
    {
      key: 'TIER_3',
      text: 'Tier 3',
    },
    {
      key: 'TIER_4',
      text: 'Tier 4',
    },
    {
      key: 'TIER_5',
      text: 'Tier 5',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['TIER_0', 'TIER_1', 'TIER_2', 'TIER_3', 'TIER_4', 'TIER_5'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 220,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
